const TOKEN_KEY = 'cm_token'
const SSO_TOKEN_KEY = 'cm_sso_token'
const USER_KEY = 'cm_user'

const KEYS = [TOKEN_KEY, SSO_TOKEN_KEY, USER_KEY]

function target(remember) {
  return remember ? localStorage : sessionStorage
}

function read(key) {
  return localStorage.getItem(key) ?? sessionStorage.getItem(key)
}

export const tokenStorage = {
  get() {
    return read(TOKEN_KEY)
  },
  getSso() {
    return read(SSO_TOKEN_KEY)
  },
  getUser() {
    try {
      return JSON.parse(read(USER_KEY))
    } catch {
      return null
    }
  },

  /**
   * Persist the session. ``remember`` decides between localStorage (survives
   * the browser being closed) and sessionStorage (tab lifetime only).
   */
  set(token, ssoToken, user, remember = true) {
    const active = target(remember)
    const stale = remember ? sessionStorage : localStorage
    KEYS.forEach((key) => stale.removeItem(key))

    if (token) active.setItem(TOKEN_KEY, token)
    if (ssoToken) active.setItem(SSO_TOKEN_KEY, ssoToken)
    if (user) active.setItem(USER_KEY, JSON.stringify(user))
  },

  setUser(user) {
    const active = localStorage.getItem(TOKEN_KEY) ? localStorage : sessionStorage
    active.setItem(USER_KEY, JSON.stringify(user))
  },

  clear() {
    ;[localStorage, sessionStorage].forEach((storage) => {
      KEYS.forEach((key) => storage.removeItem(key))
    })
  },
}
